import { render, staticRenderFns } from "./transporter-institution.vue?vue&type=template&id=ad9baf2c&"
import script from "./transporter-institution.vue?vue&type=script&lang=js&"
export * from "./transporter-institution.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports